module.exports = __webpack_public_path__ + "static/img/ent-59.f12b632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-59.jpg
// module id = octH
// module chunks = 51